import { GuiElement } from "../GuiElement"

export class Fragment extends GuiElement {}
